<template>
  <vx-card>
    <div class="vx-card__title mb-10">
      <h4 class="mb-4">Интеграция сервисов</h4>
      <p>Подключите нужный сервис.</p>
    </div>
    <div class="services-list">
      <div class="services-list__item">
        <CallTouchService
          :channel-slug="channelSlug"
        />
      </div>
    </div>
  </vx-card>
</template>

<script>
import CallTouchService from './CallTouchService'

export default {
  props: {
    channelSlug: {
      type: String,
      required: true
    }
  },

  components: {
    CallTouchService
  }
}
</script>
